import { useEffect, useState } from 'react';
import { buildMiciReport, createGapMocks, invoiceSample, seedFromProfileId } from '../engine/buildMiciReport';

/**
 * Rebuilds the MICI report when the MICI tab is active.
 * Seed is derived from profile_id so the same profile gets a stable mock across refreshes.
 */
export const useMiciReport = ({ active, businessProfile }) => {
  const [report, setReport] = useState(null);

  const profileId = businessProfile?.profile_id || businessProfile?.id || null;
  const schemeCode =
    typeof businessProfile?.scheme_agency_id === 'object'
      ? businessProfile?.scheme_agency_id?.code
      : businessProfile?.scheme_agency_id;
  const companyId = businessProfile?.company_id || null;
  const tin = businessProfile?.tin || null;
  const trn = businessProfile?.party_tax_scheme?.company_id || null;
  const name = businessProfile?.legal_name || businessProfile?.business_name || businessProfile?.name || null;

  useEffect(() => {
    if (!active) return undefined;

    const seed = seedFromProfileId(profileId || 'default');
    const gapMocks = createGapMocks(seed);
    setReport(
      buildMiciReport({
        invoices: invoiceSample,
        gapMocks,
        businessProfile,
        seed,
      }),
    );

    return undefined;
    // Intentional: only identity / registration fields — not the whole profile object.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active, profileId, schemeCode, companyId, tin, trn, name]);

  return { report };
};
